import Product from "./ui";

export default Product;
